export default "__VITE_ASSET__n7hfFTHA__"